<template>
  <div class="full-page-width relative locations">
    <div class="add-button c-float m-b-25">
      <div class="flex-center float-left">
        <Btn
          @click.native="routeIt"
          class="light bordered empty d-inline-block m-r-15 fix-40"
          :icon="{
            name: 'arrowLeftBig',
            size: '20',
          }" />
        <p class="user-name" v-if="get_consolidation !== null">{{ `${$t('consolidation')} #${get_consolidation.consolidation_number}` }}</p>
      </div>
      <Dropdown
        v-if="waybillExists()"
        class="float-right drop-right"
        :buttonText="$t('Actions')"
        :dropdownOptions="waybillDropdownOptions"
        @optionSelected="waybillOptionSelected" />
      <Dropdown
        v-if="!waybillExists()"
        class="float-right drop-right"
        :buttonText="$t('Actions')"
        :dropdownOptions="dropdownOptions"
        @optionSelected="optionSelected" />
      <a
        style="display: none"
        :download="`EOD_${consolidationId}`"
        ref="downloadEODPDF"
        :href="EODPdfPath" />
      <iframe
        style="display: none;"
        ref="printPDF"
        id="printPDF"
        name="printPDF"
        width="100%"
        :src="pdfFilePath"
        height="600px" />
    </div>
    <!-- HEADER -->
    <div class="row card info-wrap m-b-40" v-if="get_consolidation !== null">
      <div class="col-xs-3">
        <div class="info-box c-float">
          <LogosSVG
            class="float-left m-r-15"
            :name="get_consolidation.shipping_agent_name"
            size="40" />
          <div class="float-left">
            <p class="big-info-text">{{ get_consolidation.shipping_agent_name }}</p>
            <p class="small-info-text" :style="{ color: color(get_consolidation.consolidation_status) }">
              {{ $t(getStatus(get_consolidation.consolidation_status)) }} {{ formatDate(get_consolidation.consolidation_date) }}
            </p>
          </div>
        </div>
      </div>
      <div class="col-xs-3">
        <div class="info-box c-float">
          <Icon
            :circle=true
            name="savedItems"
            size="20"
            class="float-left m-r-15" />
          <div class="float-left">
            <p class="big-info-text">{{ `${get_consolidation.colli_amount} ${$t('colli').toLowerCase()}` }}</p>
            <p class="small-info-text">{{ `${get_consolidation.shipment_count} ${$t('shipments').toLowerCase()}` }}</p>
          </div>
        </div>
      </div>
      <div class="col-xs-3">
        <div class="info-box c-float">
          <Icon
            :circle=true
            name="scale"
            size="20"
            class="float-left m-r-15" />
          <div class="float-left">
            <p class="big-info-text">{{ get_consolidation.weight | weight }}</p>
            <p class="small-info-text">{{ `${get_consolidation.batch_volume} dm` }}
              <span style="vertical-align: super;
                font-size: 10px;
                line-height: 0px;">3</span>
            </p>
          </div>
        </div>
      </div>
      <div class="col-xs-3">
        <div class="info-box c-float">
          <Icon
            :circle=true
            name="single"
            size="20"
            class="float-left m-r-15" />
          <div class="float-left">
            <p class="big-info-text">{{ get_consolidation.consolidation_user_name }}</p>
            <p class="small-info-text">{{ formatDate(get_consolidation.consolidation_date, 'DD.MM.YYYY - HH:mm') }}</p>
          </div>
        </div>
      </div>
    </div>
    <!-- BARCODE & WAYBILL BOX -->
    <div class="row card info-wrap m-b-40" v-if="waybillExists()">
      <div class="col-xs-4">
        <div class="info-box c-float">
          <div class="float-left">
            <p class="big-info-text">{{ $t('waybill_number')}}</p>
            <p class="small-info-text">{{ get_consolidation_barcode.waybill_barcode }}</p>
          </div>
        </div>
      </div>
<!--      <div class="col-xs-3">-->
<!--        <div class="info-box c-float">-->
<!--          <Icon-->
<!--            :circle=true-->
<!--            name="savedItems"-->
<!--            size="20"-->
<!--            class="float-left m-r-15" />-->
<!--          <div class="float-left">-->
<!--            <p class="big-info-text">{{ $t('routing_label_number')}}</p>-->
<!--            <p class="small-info-text" v-for="(val, index) in getLabelBarcodesArray" :key="`group-${index}`"> {{ val }}</p><br>-->
<!--          </div>-->
<!--        </div>-->
<!--      </div>-->
      <div class="col-xs-4">
        <div class="info-box c-float">
          <Icon
            :circle=true
            name="pallet"
            size="20"
            class="float-left m-r-15" />
          <div class="float-left">
            <p class="big-info-text">{{ $t('load_carriers')}}</p>
            <p class="small-info-text">{{ get_consolidation_waybill.pallets }}</p>
          </div>
        </div>
      </div>
      <div class="col-xs-4" v-if="get_consolidation_email_status">
        <div class="info-box c-float">
          <Icon
            :circle=true
            name="letter"
            size="20"
            class="float-left m-r-15" />
          <div class="float-left">
            <p class="big-info-text">{{ $t('email_sent')}}</p>
            <p class="small-info-text">{{ formatDate(get_consolidation_email_status.created_at, 'DD.MM.YYYY - HH:mm') }}</p>
          </div>
        </div>
      </div>
      <!-- Hidden link element for waybill download purpose -->
      <a style="display: none"
         :download="`Waybill_${get_consolidation.consolidation_number}`"
         ref="downloadWaybillPDF"
         :href="waybillPdfPath" />
    </div>
    <!-- BODY -->
    <div class="row">
      <h2 class="m-b-20 section-title" v-if="get_consolidation_shipments !== null">
        {{ $t('Shipments') }}
        <span class="grayed">{{ `(${get_consolidation_shipments_count})` }}</span>
      </h2>
      <DataTable
        :dropdown=false
        :tableHeader=false
        :tableHead=false
        tableAPI="CONSOLIDATION_SHIPMENTS"
        tableActions="CONSOLIDATION_SHIPMENTS"
        :apiID="$route.params.id"
        :totalCount="totalCount"
        :checkbox=true
        :customTable=false
        :type=type
        :count="get_consolidation_shipments_count"
        :list="get_consolidation_shipments"
        :referenceData="referenceData"
        :filterOptions="filterOptions"
        :rowActionParameter="rowActionParameter"
        :actionsOptions="actionsOptions"
        :updateIterator="updateIterator"
        @rowAction="rowAction"
        @actionOptionTriggered="actionOptionTriggered" />
    </div>
    <a
      style="display: none"
      :download="`Consolidation.csv`"
      ref="exportData"
      :href="exportDataPath" />
    <Popup
      v-if="openPopup"
      :popupMedium=true
      :isPopupSubmitDisabled="isPopupSubmitDisabled"
      minHeight="500px"
      :confirmText="$t('generate')"
      @cancel="togglePopup"
      @confirm="submitForm">
      <template v-slot:header>
        <h2>{{ isEdit ? $t('edit_wayill_and_routing_label') : $t('create_wayill_and_routing_label') }}</h2>
      </template>
      <div>
        <InputSelect
          class="m-b-20"
          :multiSelect=false
          :label="$t('load_carriers')"
          v-model="form.pallets"
          :options="getPalletOptions"
          :rules="{required: true}"/>
        <Calendar
          class="m-b-20"
          :label="$t('sending_date')"
          v-model="form.sending_date"
          :date="form.sending_date"
          :min-date-prop="new Date()"
          :rules="{required: true}" />
        <InputSelect
          v-if="!isLetterProducts"
          class="m-b-20"
          :multiSelect=false
          :label="$t('consolidate_invoice')"
          v-model="form.consolidate_invoice"
          :options="consolidateInvoiceOptions"
          :rules="{required: true}"/>
        <div v-if="!isLetterProducts">
          <InputSelect
            :label="$t('currency')"
            v-model="form.currency_code"
            :preselected="form.currency_code"
            :options="getCurrencyList"
            :rules="{required: true}"/>
        </div>
        <InputSelect
          class="m-b-20"
          :multiSelect=false
          :label="$t('sender')"
          v-model="form.sender_id"
          :options="shipperOptions"
          :rules="{required: true}"/>
        <InputSelect
          v-if="isBringShippingAgent"
          class="m-b-20"
          :multiSelect=false
          :label="$t('terminal')"
          v-model="form.terminal_id"
          :options="getBringTerminalOptions"
          :rules="{required: true}"/>
        <!-- ostaviti ovo zakomentarisano za sada, daniel trazio da se skloni ali mozda ce se vracati kasnije -->
<!--        <InputText-->
<!--          v-if="isPostNordShippingAgent"-->
<!--          class="m-b-20"-->
<!--          :placeholder="$t('booking_number')"-->
<!--          label="Booking number"-->
<!--          v-model="form.booking_number"-->
<!--          :rules="{required: true}"/>-->
<!--        <InputText-->
<!--          v-if="isPostNordShippingAgent"-->
<!--          class="m-b-20"-->
<!--          :placeholder="$t('reference_number')"-->
<!--          label="Reference number"-->
<!--          v-model="form.reference_number"-->
<!--          :rules="{required: true}"/>-->
        <InputText
          class="m-b-20"
          :label="$t('agent_name')"
          v-model="form.agent_name"
          :rules="{required: true}"/>
        <InputText
          class="m-b-20"
          :label="$t('agent_vat')"
          v-model="form.agent_vat"
          :rules="{required: true}"/>
        <div>
          <AddressPicker
            class="m-b-20"
            :label="$t('address_1')"
            @addressSelected="changeAddress"
            v-model="formAddress"
            :rules="{required: true}"/>
        </div>
        <!-- ostaviti ovo zakomentarisano za sada, daniel trazio da se skloni ali mozda ce se vracati kasnije -->
<!--        <InputSelect-->
<!--          class="m-b-20"-->
<!--          :multiSelect=false-->
<!--          :label="$t('documents')"-->
<!--          v-model="form.document"-->
<!--          :options="getDocumentOptions"-->
<!--          :rules="{required: true}"/>-->
        <InputSelect
          v-if="isBringShippingAgent"
          class="m-b-20"
          :multiSelect=false
          :label="$t('amount')"
          v-model="form.amount"
          :options="getAmountOptions"
          :rules="{required: true}"/>
        <InputText
          v-if="isBringShippingAgent"
          class="m-b-20"
          :label="$t('weight')"
          v-model="form.weight"
          :rules="{required: true}"/>
      </div>
    </Popup>
    <Popup
      v-if="openCompletePopup"
      :popupSmall=true
      minHeight="120px"
      :confirmText="$t('complete')"
      @cancel="toggleCompletePopup"
      @confirm="submitCompletePopup">
      <template v-slot:header>
        <h2>{{ $t('complete_waybill') }}</h2>
      </template>
      <div><p>{{ $t('complete_waybill_are_you_sure_text') }}</p></div>
    </Popup>
  </div>
</template>

<script>
/* eslint-disable */
import { mapGetters } from 'vuex';
import LogosSVG from "@/assets/images/logosSVG";
import DataTable from '@/components/table/index.vue';
import Btn from '@/components/elements/buttons';
import Dropdown from '@/components/global/dropdown';
import date from '@/mixins/date';
import Popup from '@/components/global/popup';
import InputSelect from '@/components/elements/inputs/select.vue';
import InputText from '@/components/elements/inputs/text.vue';
import AddressPicker from "@/components/global/addressPicker/index.vue";
import Calendar from '@/components/elements/inputs/calendar.vue';
import mixin from '@/mixins/mixins.js';
import formValidator from '@/mixins/formValidator';
import currencyList from '@/data/currency.js';

export default {
  name: 'Consolidation',
  components: {
    LogosSVG,
    DataTable,
    Btn,
    Dropdown,
    Popup,
    InputSelect,
    InputText,
    AddressPicker,
    Calendar
  },
  mixins: [date, mixin, formValidator],
  data() {
    return {
      updateIterator: 1,
      defaultSenderId: '',
      waybillPdfPath: '',
      selectedShipper: null,
      shipperOptions: [],
      terminalOptions: [],
      consolidateInvoiceOptions: [
        {value: '0', text: 'no'},
        {value: '1', text: 'yes'}
      ],
      openPopup: false,
      openCompletePopup: false,
      isEdit: false,
      consolidationId: '',
      totalCount: 300,
      formAddress: {
        address_1: '',
        address_2: '',
        post_code: '',
        city: '',
        country_id: '',
        state: '',
      },
      form: {
        sender_id: '',
        terminal_id: '',
        booking_number: '',
        reference_number: '',
        agent_name: '',
        agent_vat: '',
        document: '',
        amount: '',
        pallets: '',
        weight: '',
        sending_date: '',
        consolidate_invoice: '1',
        currency_code: ''
      },
      usersLastWaybillData: {
        agent_name: '',
        agent_vat: '',
        agent_address: '',
        agent_post_code: '',
        agent_city: '',
        country_id: '',
        sender_id: '',
        currency_code: ''
      },
      bringWaybillData: {
        terminals: [
          {
            'id': 1,
            'country_code': 'NO',
            'name': 'Østlandsterminalen (Bring Mail Nordic)',
            'city': 'Oslo',
            'postcode': '0014',
            'address': 'V/Inntektssikring',
            'country': 'Norge'
          },
          {
            'id': 2,
            'country_code': 'NO',
            'name': 'Postens Østlandsterminal (brev)',
            'city': 'Lørenskog',
            'postcode': '1470',
            'address': 'Lørenskogveien 50',
            'country': 'Norge'
          },
          {
            'id': 3,
            'country_code': 'NO',
            'name': 'Posten Norge',
            'city': 'Gardermoen',
            'postcode': '2061',
            'address': 'EMS-Gardermoen',
            'country': 'Norge'
          },
          {
            'id': 4,
            'country_code': 'NO',
            'name': 'Postens Godssenter',
            'city': 'Oslo',
            'postcode': '0024',
            'address': 'Alfasetveien 24',
            'country': 'Norge'
          },
          {
            'id': 5,
            'country_code': 'DE',
            'name': 'Deutsche Post World Net',
            'city': 'Hamburg',
            'postcode': '21035',
            'address': 'Rungedamm 37a',
            'country': 'Tyskland'
          },
          {
            'id': 6,
            'country_code': 'DE',
            'name': 'Hermes (HUB)',
            'city': 'Hamburg',
            'postcode': '22172',
            'address': 'Im Otto Versand Hamburg Bramfeld Wandsbeker Str 3-7',
            'country': 'Tyskland'
          },
          {
            'id': 7,
            'country_code': 'DE',
            'name': 'Deutsche Post DHL',
            'city': 'Hamburg',
            'postcode': '22769',
            'address': 'Plöner Str. 10',
            'country': 'Tyskland'
          },
          {
            'id': 8,
            'country_code': 'DK',
            'name': 'Bring Parcels AB',
            'city': 'Kastrup',
            'postcode': '2770',
            'address': 'Fuglebækvej 5-9',
            'country': 'Danmark'
          },
          {
            'id': 9,
            'country_code': 'DK',
            'name': 'Bring Parcels AB',
            'city': 'Kolding',
            'postcode': '6000',
            'address': 'Birkedam 18',
            'country': 'Danmark'
          },
          {
            'id': 10,
            'country_code': 'DK',
            'name': 'Post Denmark',
            'city': 'Brøndby',
            'postcode': '2605',
            'address': 'Priorparken 385',
            'country': 'Danmark'
          },
          {
            'id': 11,
            'country_code': 'DK',
            'name': 'Post Denmark',
            'city': 'Fredericia',
            'postcode': '7000',
            'address': 'Stakkesvang 15, Taulov',
            'country': 'Danmark'
          },
          {
            'id': 12,
            'country_code': 'EE',
            'name': 'AS Eesti Post',
            'city': 'Tallin',
            'postcode': '10001',
            'address': 'Pallasti 28',
            'country': 'Estland'
          },
          {
            'id': 13,
            'country_code': 'FI',
            'name': 'Posti Oy Logistics Center',
            'city': 'Vantaa',
            'postcode': '01530',
            'address': 'Dickursbyvägen 148',
            'country': 'Finland'
          },
          {
            'id': 14,
            'country_code': 'FI',
            'name': 'Posti Oy - Böle Mail-terminal',
            'city': 'Helsinki',
            'postcode': '00230',
            'address': 'Postintaival 9',
            'country': 'Finland'
          },
          {
            'id': 15,
            'country_code': 'FI',
            'name': 'Posti Oy Int Mail terminal',
            'city': 'Vantaa',
            'postcode': '01530',
            'address': 'Vingvägen 9',
            'country': 'Finland'
          },
          {
            'id': 16,
            'country_code': 'FI',
            'name': 'Posti Oy',
            'city': 'Turku',
            'postcode': '20250',
            'address': 'Uhrilähteenkatu 21',
            'country': 'Finland'
          },
          {
            'id': 17,
            'country_code': 'FI',
            'name': 'Bring Finland',
            'city': 'Vantaa',
            'postcode': '01740',
            'address': 'Nuolitie 9',
            'country': 'Finland'
          },
          {
            'id': 18,
            'country_code': 'FI',
            'name': 'Posti Oy Logistics Center',
            'city': 'Lieto',
            'postcode': '21240',
            'address': 'Ahtonkaari 5',
            'country': 'Finland'
          },
          {
            'id': 19,
            'country_code': 'FO',
            'name': 'Postverk Føroya',
            'city': 'Torshavn',
            'postcode': '100',
            'address': 'Odinshædd 2',
            'country': 'Færøerne'
          },
          {
            'id': 20,
            'country_code': 'GB',
            'name': 'Parcelforce Worldwide',
            'city': 'Coventry',
            'postcode': 'CV3 4PF',
            'address': 'Siskin Parkway West Middlemarch Business Park',
            'country': 'Storbritannien'
          },
          {
            'id': 21,
            'country_code': 'IS',
            'name': 'Iceland Post',
            'city': 'Reykjavik',
            'postcode': '110',
            'address': 'Storhofda 32',
            'country': 'Island'
          },
          {
            'id': 22,
            'country_code': 'NL',
            'name': 'TNT Post Parcel Service',
            'city': 'Amsterdam',
            'postcode': '1042AB',
            'address': 'Gyroscoopweg 10-12',
            'country': 'Nederlandene'
          },
          {
            'id': 23,
            'country_code': 'SE',
            'name': 'Bring Parcels AB',
            'city': 'Jönköping',
            'postcode': '55652',
            'address': 'Bordsvägen 3',
            'country': 'Sverige'
          },
          {
            'id': 24,
            'country_code': 'SE',
            'name': 'DHL Freight',
            'city': 'Jönköping',
            'postcode': '55303',
            'address': 'Verktygsvägen 19',
            'country': 'Sverige'
          },
          {
            'id': 25,
            'country_code': 'SE',
            'name': 'DHL Freight',
            'city': 'Arlöv',
            'postcode': '23291',
            'address': 'Flansbjersvägen 10-12, port 7-9',
            'country': 'Sverige'
          },
          {
            'id': 26,
            'country_code': 'SE',
            'name': 'DHL Freight',
            'city': 'Hisings Backa',
            'postcode': '42246',
            'address': 'Importgatan 27',
            'country': 'Sverige'
          },
        ],
        documents: [
          {value: 'Invoice', 'text': 'Invoice'},
          {value: 'EUR-certificate', text: 'EUR-certificate'},
          {value: 'Export notification', text: 'Export notification'},
        ],
        amount: [...Array(10).keys()].map((val, index) => {
          val = (val + 1).toString();
          return {value: val, text: val};
        }), //{min: 1, max: 10},
        pallets: [...Array(10).keys()].map((val, index) => {
          val = (val + 1).toString();
          return {value: val, text: val};
        }), //{min: 1, max: 10},

        //when inserting new waybill range first copy old min and max to last_min and last_max
        'waybill_barcode': {
          'prefix': 'CS',
          'min': '06366000',
          'max': '06415999',
          'suffix': 'NO',
          'last_min': '0',
          'last_max': '0'
        },

        //when inserting new label range first copy old min and max to last_min and last_max
        'label_barcode': {
          'prefix': 'CS',
          'min': '17245000',
          'max': '17344999',
          'suffix': 'NO',
          'last_min': '0',
          'last_max': '0'
        },
      },
      postNordWaybillData: {
        documents: [
          {value: 'Invoice', 'text': 'Invoice'},
          {value: 'EUR-certificate', text: 'EUR-certificate'},
          {value: 'Export notification', text: 'Export notification'},
          {value: 'Annexed documents', text: 'Annexed documents'},
        ],
        pallets: [...Array(9).keys()].map((val, index) => {
          val = (val + 1).toString();
          return {value: val, text: val};
        }), //{min: 1, max: 10},
        prefix: 'DO',
        suffix: 'DK'
      },
      type: {
        type: true,
        data: 'goods_type',
        text: 'Type',
        icons: {
          1 : 'savedItems',
          2 : 'documentGoods',
          3 : 'pallet',
          4 : 'load'
        },
      },
      rowActionParameter: {
        param: 'id',
        text: `${this.$t('View shipment')}`,
      },
      referenceData: [
        {
          shipping_product_name: `${this.$t('Shipping product name')}`,
          shipping_agent_name: `${this.$t('Shipping agent name')}`,
        },
        {
          trace_no: `${this.$t('track_number')}`,
          //trace_no: `${this.$t('Trace number')}`,
        },
        {
          sender_reference: `${this.$t('Sender ref.:')}`,
          receiver_reference: `${this.$t('Reciever ref.:')}`,
        },
      ],
      actionsOptions: [
        {
          text: `${this.$t('remove_from_consolidation')}`,
          subText: `${this.$t('remove_from_consolidation_subtext')}`,
          icon: 'deleteForever',
        },
        {
          text: `${this.$t('download_cons_shipment')}`,
          subText: `${this.$t('download_cons_shipment_subtext')}`,
          icon: 'cloudDownload',
        },
      ],
      dropdownOptions: [], //dynamic
      waybillDropdownOptions: [], //dynamic
      EODPdfPath: '',
      pdfFilePath: '',
      exportDataPath: '',
    };
  },
  computed: {
    ...mapGetters([
      'get_shippers',
      'get_filters_menu',
      'get_active_filter',
      'get_consolidation',
      'get_consolidation_barcode',
      'get_consolidation_waybill',
      'get_consolidation_shipments',
      'get_consolidation_shipments_count',
      'get_consolidation_email_status',
      'get_consolidation_product_types'
    ]),
    isLetterProducts() {
      const carrierProduct = this.get_consolidation_shipments[0].product_key;
      const type           = this.get_consolidation_product_types[carrierProduct];

      //Tracked and untracked letter type
      return !!(type && [2, 3].includes(type));
    },
    isBringShippingAgent() {
      return parseInt(this.get_consolidation.shipping_agent_id) === 3;
    },
    isPostNordShippingAgent() {
      return parseInt(this.get_consolidation.shipping_agent_id) === 1;
    },
    getLabelBarcodesArray() {
      if (this.get_consolidation_barcode.label_barcode) {
        return this.get_consolidation_barcode.label_barcode.split(',');
      }

      return [];
    },
    getDocumentOptions() {
      if (this.isBringShippingAgent) {
        return this.bringWaybillData.documents
      } else if (this.isPostNordShippingAgent) {
        return this.postNordWaybillData.documents;
      } else {
        console.log('Unallowed shipping agent');
      }
    },
    getCurrencyList() {
      const array = [];
      Object.keys(currencyList).forEach((key, index) => {
        array.push({
          text: key.toUpperCase(),
          value: key.toUpperCase(),
        });
      });
      return array;
    },
    getPalletOptions() {
      if (this.isBringShippingAgent) {
        return this.bringWaybillData.pallets
      } else if (this.isPostNordShippingAgent) {
        return this.postNordWaybillData.pallets;
      } else {
        console.log('Unallowed shipping agent');
      }
    },
    getAmountOptions() {
      if (this.isBringShippingAgent) {
        return this.bringWaybillData.amount
      } else {
        console.log('Unallowed shipping agent');
      }
    },
    getBringTerminalOptions() {
      this.terminalOptions = [
        ...this.bringWaybillData.terminals.map((opt) => {
          return {
            value: opt.id,
            text:
              `${opt.country_code ? opt.country_code + ', ' : ''}
                ${opt.name ? opt.name + ', ' : ''}
                ${opt.city}`
          };
        }),
      ];

      return this.terminalOptions;
    },
    filterOptions() {
      return {
        filtersMenu: this.get_filters_menu,
        activeFilter: this.get_active_filter,
        tableName: 'allShipments',
        filterFields: [
          {
            label: this.$t('name'),
            type: 'input',
            model: 'name',
          },
          {
            label: this.$t('customer_no'),
            type: 'input',
            model: 'customer_number',
          }
        ],
      }
    },
    isPopupSubmitDisabled() {
      if (this.form.consolidate_invoice === '') return false;

      let formWithValidators = [
        //Address data
        {
          formFeild:'address_1',
          value: this.formAddress.address_1,
          validators:{required: true}
        },
        {
          formFeild:'post_code',
          value: this.formAddress.post_code,
          validators:{required: true}
        },
        {
          formFeild:'city',
          value: this.formAddress.city,
          validators:{required: true}
        },
        {
          formFeild:'country_id',
          value: this.formAddress.country_id,
          validators:{required: true}
        },
        //Form data
        {
          formFeild:'sender_id',
          value: this.form.sender_id,
          validators:{required: true}
        },
        {
          formFeild:'agent_name',
          value: this.form.agent_name,
          validators:{required: true}
        },
        {
          formFeild:'agent_vat',
          value: this.form.agent_vat,
          validators:{required: true}
        },
        // {
        //   formFeild:'document',
        //   value: this.form.document,
        //   validators:{required: true}
        // },
        {
          formFeild:'pallets',
          value: this.form.pallets,
          validators:{required: true}
        },
        {
          formFeild:'sending_date',
          value: this.form.sending_date,
          validators:{required: true}
        },
      ];

      if (!this.isLetterProducts) {
        formWithValidators.push({
          formFeild:'currency_code',
          value: this.form.currency_code,
          validators: {required: true}
        })
      }

      if (this.isBringShippingAgent) {
        formWithValidators.push({
          formFeild: 'terminal_id',
          value: this.form.terminal_id,
          validators: {required: true}
        });
        formWithValidators.push({
          formFeild: 'amount',
          value: this.form.amount,
          validators: {required: true}
        });
        formWithValidators.push({
          formFeild: 'weight',
          value: this.form.weight,
          validators: {required: true}
        });
      }

      if (this.isPostNordShippingAgent) {
        // formWithValidators.push({
        //   formFeild: 'booking_number',
        //   value: this.form.booking_number,
        //   validators: {required: true}
        // });
        //
        // formWithValidators.push({
        //   formFeild: 'reference_number',
        //   value: this.form.reference_number,
        //   validators: {required: true}
        // });
      }

      return this.validateInput(formWithValidators);
    },
  },
  async created() {
    this.consNumber = this.$route.params.id;
    await this.$store.dispatch('GET_CONSOLIDATION', this.consNumber).then((res) => {
      this.setDropdownOptions();
      this.setWaybillDropdownOptions();
      this.$store.dispatch('GET_SHIPPERS').then((res) => {
        this.shipperOptions = [
          ...res.map((opt) => {
            if (opt.is_default) {
              this.defaultSenderId = opt.id
            }

            return {
              value: opt.id,
              text:
                `${opt.company_name ? opt.company_name + ', ' : ''}
                ${opt.name ? opt.name + ', ' : ''}
                ${opt.address_1 ? opt.address_1 + ', ' : ''}
                ${opt.post_code ? opt.post_code + ', ' : ''}
                ${opt.city ? opt.city + ', ' : ''}
                ${opt.state ? opt.state + ', ' : ''}
                ${opt.country_id ? this.getCountry(opt.country_id, 'name') : ''}`
            };
          }),
        ];
      })
    });
    await this.$store.dispatch('GET_LAST_USED_WAYBILL_DATA', {
        id: this.$route.params.id,
        agent_id: this.get_consolidation.shipping_agent_id
      }
    ).then((res) => {
      if (res) {
        this.usersLastWaybillData = res;
      }
    });
  },
  methods: {
    getStatus(statusId) {
      if (statusId == 1) {
        return 'draft';
      } else if (statusId == 2) {
        return 'ready';
      } else if (statusId == 3) {
        return 'completed';
      }
    },
    color(status) {
      if (status == 1) {
        return '';
      } else if (status == 2) {
        return '#FFCB52';
      } else if (status == 3) {
        return '#60D27C';
      }
    },
    waybillExists() {
      if (typeof this.get_consolidation_waybill == 'undefined'
        || typeof this.get_consolidation_barcode == 'undefined') {
        return false;
      }

      return this.get_consolidation_waybill !== null && this.get_consolidation_barcode !== null;
    },
    setDropdownOptions() {
      let actions = [];

      if (!this.waybillExists()) {
        actions.push({
          text: `${this.$t('add_waybill')}`,
          subText: `${this.$t('add_waybill_subtext')}`,
          icon: 'plus',
        });
      }

      this.dropdownOptions = actions;
    },
    setWaybillDropdownOptions() {
      let options = [
        {
          text: `${this.$t('print_waybill')}`,
          subText: `${this.$t('print_waybill_subtext')}`,
          icon: 'printer',
        },
        {
          text: `${this.$t('download_docs')}`,
          subText: `${this.$t('download_documents')}`,
          icon: 'cloudDownload',
        },
      ];

      //If waybill exist and consolidation status is ready show complete and edit waybill options
      if (this.waybillExists() && parseInt(this.get_consolidation.consolidation_status) === 2) {
        options.push(
          {
            text: `${this.$t('complete_waybill')}`,
            subText: `${this.$t('complete_waybill_subtext')}`,
            icon: 'todo'
          }
        );
        options.push(
          {
            text: `${this.$t('edit_waybill')}`,
            subText: `${this.$t('edit_waybill_subtext')}`,
            icon: 'pen',
          }
        )
      }

      this.waybillDropdownOptions = options;
    },
    downloadWaybill() {
      //Download consolidation documents
      this.$store.dispatch('DOWNLOAD_CONSOLIDATION_WAYBILL', {id: this.$route.params.id}).then((res) => {
        this.$nextTick(() => {
          let file = window.URL.createObjectURL(res);
          this.$refs.downloadWaybillPDF.href = file;
          this.waybillPdfPath = file;
          this.$refs.downloadWaybillPDF.click();
        })
      })
    },
    changeAddress(val) {
      this.formAddress.address_1 = val.address_1;
      this.formAddress.address_2 = val.address_2 || '';
      this.formAddress.country_id = val.country_id;
      this.formAddress.post_code = val.post_code;
      this.formAddress.city = val.city;
      this.formAddress.state = val.state;
    },
    rowAction(val) {
      this.$router.push(`/view-shipment/${val}`);
    },
    optionSelected(opt) {
      if(opt === 'dropOption1' && !this.waybillExists()) {
        this.togglePopup();
      }
    },
    waybillOptionSelected(opt) {
      if(opt === 'dropOption1') {
        this.$store.dispatch('PRINT_CONSOLIDATION', this.$route.params.id);
      } else if(opt === 'dropOption2') {
        this.downloadWaybill()
      } else if(opt === 'dropOption3') {
        this.toggleCompletePopup()
      } else if(opt === 'dropOption4') {
        this.openEditPopup()
      }
    },
    submitForm() {
      if (this.isLetterProducts) {
        this.form.consolidate_invoice = '0';
      }

      const action = this.isEdit ? 'EDIT_WAYBILL_AND_ROUTING_LABEL' : 'CREATE_WAYBILL_AND_ROUTING_LABEL';
      this.$store.dispatch(action, {
        id: this.$route.params.id,
        form: {
          ...this.form,
          agent_address: this.formAddress.address_1,
          agent_post_code: this.formAddress.post_code,
          agent_city: this.formAddress.city,
          country_id: this.formAddress.country_id,
          shipping_agent_id: this.get_consolidation.shipping_agent_id,
          consolidation_number: this.get_consolidation.consolidation_number,
          document: 'Invoice' // zakucano jer je sklonjen dropdown
        }
      }).then((res) => {
        this.togglePopup();
        this.isEdit = false;
        this.$store.dispatch('GET_CONSOLIDATION', this.$route.params.id).then(() => {
          this.setDropdownOptions();
          this.setWaybillDropdownOptions();
        })
      }).catch((e) => {
        console.log(e.message)
      })
    },
    submitCompletePopup() {
      this.toggleCompletePopup()
      this.$store.dispatch('COMPLETE_CONSOLIDATION_WAYBILL', this.$route.params.id).then(() => {
        this.$store.dispatch('GET_CONSOLIDATION', this.$route.params.id);
      })
    },
    togglePopup() {
      this.openPopup = !this.openPopup;
      this.resetForm();
    },
    toggleCompletePopup() {
      this.openCompletePopup = !this.openCompletePopup;
    },
    openEditPopup(id) {
      this.togglePopup();
      this.isEdit = true;
      const today = new Date();
      const data = this.get_consolidation_waybill;
      const sendingDate = new Date(data.sending_date);
      this.form = {
        sender_id: data.sender_id,
        terminal_id: data.terminal_id,
        booking_number: data.booking_number,
        reference_number: data.reference_number,
        agent_name: data.agent_name,
        agent_vat: data.agent_vat,
        document: data.document,
        amount: data.amount,
        pallets: data.pallets,
        weight: data.weight,
        sending_date: sendingDate < today ? today : sendingDate,
        consolidate_invoice: '1',
        currency_code: data.currency_code
      };
      this.formAddress = {
        address_1: data.agent_address,
        address_2: '',
        post_code: data.agent_post_code,
        city: data.agent_city,
        country_id: data.country_id,
        state: ''
      };
    },
    resetForm() {
      this.formAddress = {
        address_1: this.usersLastWaybillData.agent_address ?? '',
        address_2: '',
        post_code: this.usersLastWaybillData.agent_post_code ?? '',
        city: this.usersLastWaybillData.agent_city ?? '',
        country_id: this.usersLastWaybillData.country_id ?? '',
        state: '',
      };

      this.form = {
        sender_id: this.usersLastWaybillData.sender_id ?? this.defaultSenderId,
        terminal_id: '',
        booking_number: '',
        reference_number: '',
        agent_name: this.usersLastWaybillData.agent_name ?? '',
        agent_vat: this.usersLastWaybillData.agent_vat ?? '',
        document: 'Invoice',//zakucano
        amount: '',
        pallets: '',
        weight: '',
        sending_date: '',
        consolidate_invoice: '1',
        currency_code: this.usersLastWaybillData.currency_code ?? ''
      };
    },
    actionOptionTriggered(val) {
      if (val.dropOption == 'dropOption1') {
        this.$store.dispatch('REMOVE_SHIPMENTS_FROM_CONSOLIDATION', {
          id: this.$route.params.id,
          shipment_ids: val.list,
        }).then((res) => {
          this.updateIterator++
          this.$store.dispatch('GET_CONSOLIDATION_SHIPMENTS', {id: this.$route.params.id, page: 1 })
            .then((res) => {
              //If there is no shipments on consolidation redirect user to index page
              if (res.count < 1) {
                this.$router.go(-1);
              }
          })
        });
      }
      if(val.dropOption == 'dropOption2'){
        this.$store.dispatch('EXPORT_CSV', {
          tableName: 'consolidation_shipments',
          ids: val.list,
        }).then((res) => {
          this.$nextTick(() => {
            const blob = new Blob([res], {type: "octet/stream"});
            const url = window.URL.createObjectURL(blob);
            this.$refs.exportData.href = url;
            // this.$refs.exportData.href = 'data:attachment/csv;charset=utf-8,' + encodeURI(res);
            this.$refs.exportData.click();
            window.URL.revokeObjectURL(url);
          })
        });
      }
    },
    routeIt() {
      this.$router.go(-1);
    },
    downloadPDF() {
      this.$store.dispatch('DOWNLOAD_EOD', this.consolidationId).then((res) => {
        this.$nextTick(() => {
          let file = window.URL.createObjectURL(res);
          this.$refs.downloadEODPDF.href = file;
          this.EODPdfPath = file;
          this.$refs.downloadEODPDF.click();
        })
      })
    },
    printPDF() {
      this.$store.dispatch('PRINT_EOD', this.consolidationId).then((res) => {
        if(res == true){
          this.$store.dispatch('DOWNLOAD_EOD', this.consolidationId).then((res) => {
            this.$nextTick(() => {
              const urlCreator = window.URL || window.webkitURL;
              let file = urlCreator.createObjectURL(res);
              // this.pdfFilePath = file;
              this.$refs.printPDF.src = file;
              this.$refs.printPDF.onload = () => {
                var self = this;
                setTimeout(() => {
                  self.printPDFEOD();
                }, 1);
              };
            })
          })
        }
      })
    },
    printPDFEOD() {
      this.$refs.printPDF.contentWindow.print();
    },
  },
  destroyed() {
    this.$store.dispatch('CLEAR_SINGLE_CONSOLIDATION');
  },
}
</script>
